// extracted by mini-css-extract-plugin
export default {"cardimage":"BlogCard_cardimage__1Ex1l","carouselstyle":"BlogCard_carouselstyle__WwFyc","cards":"BlogCard_cards__jaxBx","cartext":"BlogCard_cartext__jfv9c"};